export interface AwardShowcaseItem {
    id: string;
    name: string;
    title: string;
    year: string;
    image: string;
    href?: string;
}

export const awardShowcaseItems: AwardShowcaseItem[] = [
    {
        id: 'dezeen-sustainable-design',
        name: 'Dezeen Awards',
        title: 'Sustainable Design of the Year',
        year: '2025',
        image: 'https://d1tg5gdu842vo5.cloudfront.net/site-assets/media/2026/06/30/c5f1deac493c47b296b594635c0d88c4-dezeen_award_sticker.webp',
        href: '/blog/kibu-wins-dezeen-awards-sustainable-design-of-the-year/',
    },
    {
        id: 'tct-consumer-product',
        name: 'TCT Awards',
        title: 'Consumer Product Application',
        year: '2025',
        image: 'https://d1tg5gdu842vo5.cloudfront.net/site-assets/media/2026/06/30/ae3050a586614028b4a3c9713ea2e029-tct_award_sticker.webp',
        href: '/blog/kibu-wins-tct-award-featured-tct-magazine/',
    },
    {
        id: 'better-future-circular-economy',
        name: 'Better Future Awards',
        title: 'Gold, Circular Economy',
        year: '2026',
        image: 'https://d1tg5gdu842vo5.cloudfront.net/site-assets/media/2026/06/30/2f45d39fa5cd418c83a19deb37ae9fea-world_design_awards.webp',
        href: '/blog/kibu-wins-gold-at-the-better-future-awards-for-circular-economy/',
    },
    {
        id: 'dandad-product-design',
        name: 'D&AD',
        title: 'Wood Pencil, Product Design',
        year: '2024',
        image: 'https://d1tg5gdu842vo5.cloudfront.net/site-assets/media/2026/06/30/a79db7a6607d430a94e267dc2448d707-d&ad_award_sticker.webp',
        href: '/blog/kibu-wins-dandad-pencil-product-design/',
    },
];
